<template>
  <v-row>
    <v-col cols="12">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="720px"
        @click:outside="closeDialog()"
      >
        <v-card>
          <!-- <v-form ref="form" lazy-validation> -->
          <v-card-title>
            <span>Details</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="mt-0 pt-0">
                  <table class="retailer-details">
                    <tr>
                      <td class="w-40">Name:</td>
                      <td>{{ data.firstName }} {{ data.lastName }}</td>
                    </tr>
                    <tr>
                      <td>Mobile Number:</td>
                      <td>{{ data.mobileNumber }}</td>
                    </tr>
                    <tr>
                      <td>City:</td>
                      <td>{{ data.city }}</td>
                    </tr>
                    <tr>
                      <td>Region:</td>
                      <td>{{ data.region }}</td>
                    </tr>
                  </table>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="mt-0 pt-0">
                  <v-data-table
                    :headers="table.headers"
                    :items="table.data"
                    :items-per-page="10"
                    :loading="table.loading"
                    item-key="id"
                    :search="search"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                  >
                    <template v-slot:[`item.amount`]="{ item }">
                      {{ item.amount.toLocaleString() }}
                    </template>

                    <template v-slot:[`item.name`]="{ item }">
                      {{ item.name ? item.name : "-" }}
                    </template>
                    <template
                      v-for="header in table.headers.filter((header) =>
                        header.hasOwnProperty('formatter')
                      )"
                      v-slot:[`item.${header.value}`]="{ value }"
                    >
                      {{ header.formatter(value) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn :disabled="loadingBtn" @click="closeDialog()">
              Close
            </v-btn>
            <!-- <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn> -->
          </v-card-actions>
          <!-- </v-form> -->
        </v-card>
      </v-dialog>
      <!-- <Snackbar></Snackbar> -->
    </v-col>
  </v-row>
</template>

<script>
// import Snackbar from "../Snackbar.vue";
import moment from "moment";
export default {
  name: "RetailerDetailsDialog",
  components: {
    // Snackbar,
  },
  props: ["dialog", "data", "reportName"],
  data() {
    return {
      exportData: [],
      fileName: "",

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      search: "",
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "dateLabel",
          formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
        },
        {
          text: "Customer Name",
          align: "start",
          value: "customerName",
        },
        {
          text: "SKU",
          align: "start",
          value: "name",
        },
        {
          text: "Amount",
          align: "start",
          value: "amount",
        },
      ],
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        headers: [],
        data: [],
      },
    };
  },
  methods: {
    async getList(data, reportName = "subscriber-transactions") {
      // subscriber-transactions
      this.table.loading = true;
      await this.$api
        .get(
          `/acquisition/report?report=${reportName}&retailerId=${data.retailerId}&startDate=${data.summary.fromDate}&endDate=${data.summary.toDate}`
        )
        .then((response) => {
          // console.log(response);
          const newArr = response.data.data.transactions;
          // console.log("report", newArr);
          this.table.data = newArr;
          let exportData = {};
          if (this.$props.reportName === "retailer-daily-total-sales") {
            exportData = newArr.map((item) => {
              return {
                Date: moment(item.dateLabel).format("MMM DD, YYYY"),
                Amount: item.amount,
              };
            });
          } else {
            exportData = newArr.map((item) => {
              return {
                Date: moment(item.dateLabel).format("MMM DD, YYYY"),
                "Customer Name": item.customerName,
                SKU: item.name,
                Amount: item.amount,
              };
            });
          }

          this.fileName = `${data.firstName} ${data.lastName}_${data.summary.fromDate}_${data.summary.toDate}`;
          this.exportData = exportData;
          // console.log();

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    closeDialog() {
      this.$emit("close", false);
      // this.$refs.form.reset();
    },
  },

  created() {},

  watch: {
    dialog(val) {
      if (val) {
        this.getList(this.$props.data, this.$props.reportName);

        if (this.$props.reportName === "retailer-daily-total-sales") {
          this.table.headers = this.headers;
          this.table.headers = this.table.headers.filter(
            (header) => header.text !== "SKU" && header.text !== "Customer Name"
          );
        } else {
          this.table.headers = this.headers;
        }
      }
    },

    // reportName() {
    //   if(){
    //     console.log("asdsad")
    //   }
    // }
  },

  computed: {},
};
</script>

<style scoped>
table.retailer-details {
  width: 100%;
  border-collapse: collapse;
  /* border: 1px solid #e2e2e2; */
  text-align: left;
}

table.retailer-details tr,
td,
th {
  padding: 10px 10px;
  border: 1px solid #e2e2e2;
}

.w-40 {
  width: 40%;
}
</style>
